import yoga, {Node} from 'yoga-layout-prebuilt';
import Big from 'big.js';

const componentHelper = {
    enums: {
        position: {
            'absolute': yoga.POSITION_TYPE_ABSOLUTE,
            'relative': yoga.POSITION_TYPE_RELATIVE,
        },
        edge: {
            'all': yoga.EDGE_ALL,
            'horizontal': yoga.EDGE_HORIZONTAL,
            'vertical': yoga.EDGE_VERTICAL,
            'left': yoga.EDGE_LEFT,
            'right': yoga.EDGE_RIGHT,
            'top': yoga.EDGE_TOP,
            'bottom': yoga.EDGE_BOTTOM,
            'start': yoga.EDGE_START,
            'end': yoga.EDGE_END,
        },
        flexDirection: {
            'row': yoga.FLEX_DIRECTION_ROW,
            'column': yoga.FLEX_DIRECTION_COLUMN,
            'row-reverse': yoga.FLEX_DIRECTION_ROW_REVERSE,
            'column-reverse': yoga.FLEX_DIRECTION_COLUMN_REVERSE,
        },
        justifyContent: {
            'flex-start': yoga.JUSTIFY_FLEX_START,
            'flex-end': yoga.JUSTIFY_FLEX_END,
            'center': yoga.JUSTIFY_CENTER,
            'space-between': yoga.JUSTIFY_SPACE_BETWEEN,
            'space-evenly': yoga.JUSTIFY_SPACE_EVENLY,
            'space-around': yoga.JUSTIFY_SPACE_AROUND,
        },
        alignItems: {
            'flex-start': yoga.ALIGN_FLEX_START,
            'flex-end': yoga.ALIGN_FLEX_END,
            'center': yoga.ALIGN_CENTER,
        },
        alignContent: {
            'flex-start': yoga.ALIGN_FLEX_START,
            'flex-end': yoga.ALIGN_FLEX_END,
        },
        flexWrap: {
            'wrap': yoga.WRAP_WRAP,
            'nowrap': yoga.WRAP_NO_WRAP,
            'wrap-reverse': yoga.WRAP_WRAP_REVERSE,
        }
    },
    getEnum: function (k, v) {
        return componentHelper.enums[k][v];
    },
    toPixels: function (value) {
        if (value === null) {
            return null;
        }
        return value * 1000;
    },
    toMeters: function (value) {
        if (value === null) {
            return null;
        }
        let x = new Big(value / 1000);
        return x.toFixed(4);
    },
}

AFRAME.registerComponent('yoga-layout-item', {
    schema: {
        align: {type: 'string', default: 'flex-start'},
        padding: {type: 'number', default: 0},
        paddingEdge: {type: 'string', default: 'all'},
        margin: {type: 'number', default: 0},
        marginEdge: {type: 'string', default: 'all'},
        position: {type: 'string', default: 'relative'},
        left: {type: 'number', default: null},
        right: {type: 'number', default: null},
        top: {type: 'number', default: null},
        bottom: {type: 'number', default: null},
    },
    update: function (oldData) {
        const me = this;
        me.el.emit('geometry-changed');
    },
    init: function () {
        const me = this;

        if (!me.el.components.hasOwnProperty('visible')) {
            me.el.setAttribute('visible', true);
        }

        me.el.addEventListener('componentchanged', function (event) {
            if (event.detail.name === 'geometry') {
                me.el.emit('geometry-changed');
            }
            if (event.detail.name === 'visible') {
                me.el.emit('geometry-changed');
            }
        });
    },
});

AFRAME.registerComponent('yoga-layout', {
    dependencies: [],
    schema: {
        width: {type: 'number', default: 1},
        height: {type: 'number', default: 1},
        widthAuto: {type: 'number', default: 0},
        heightAuto: {type: 'number', default: 0},
        padding: {type: 'number', default: 0},
        paddingEdge: {type: 'string', default: 'all'},
        margin: {type: 'number', default: 0},
        marginEdge: {type: 'string', default: 'all'},
        flexDirection: {type: 'string', default: 'row'},
        justifyContent: {type: 'string', default: 'flex-start'},
        alignContent: {type: 'string', default: 'flex-start'},
        alignItems: {type: 'string', default: 'flex-start'},
        flexWrap: {type: 'string', default: 'wrap'}
    },
    init: function () {
        const me = this;

        for (let child of me.el.children) {
            if (!child.components['yoga-layout-item']) {
                child.setAttribute('yoga-layout-item', {
                    margin: 0, marginEdge: 'all',
                    padding: 0, paddingEdge: 'all',
                });
            }
            child.addEventListener('geometry-changed', function () {
                me.renderLayout('child-geometry-changed');
            });
        }

        me.el.addEventListener('child-attached', function (event) {

            let child = event.detail.el;
            if (!child.components['yoga-layout-item']) {
                child.setAttribute('yoga-layout-item', {
                    margin: 0, marginEdge: 'all',
                    padding: 0, paddingEdge: 'all',
                });
            }
            child.addEventListener('geometry-changed', function () {
                me.renderLayout('child-geometry-changed');
            });
            me.renderLayout('child-attached');
        });

        me.el.addEventListener('child-removed', function (evt) {
            me.renderLayout('child-removed');
        });

        me.renderLayout('init');
    },
    update: function (oldData) {
        const me = this;
        me.renderLayout('update');
    },
    needRenderLayout: false,
    renderLayout: function (reason) {
        this.needRenderLayout = true;
    },
    tick: function () {
        if (this.needRenderLayout) {
            this.needRenderLayout = false;
            this._renderLayout();
        }
    },
    _renderLayout: function () {
        const me = this;

        // console.log('_renderLayout', me);

        const width = componentHelper.toPixels(me.data.width);
        const height = componentHelper.toPixels(me.data.height);
        const margin = componentHelper.toPixels(me.data.margin);
        const marginEdge = componentHelper.getEnum('edge', me.data.marginEdge);
        const padding = componentHelper.toPixels(me.data.padding);
        const paddingEdge = componentHelper.getEnum('edge', me.data.paddingEdge);
        const flexDirection = componentHelper.getEnum('flexDirection', me.data.flexDirection);
        const justifyContent = componentHelper.getEnum('justifyContent', me.data.justifyContent);
        const alignContent = componentHelper.getEnum('alignContent', me.data.alignContent);
        const alignItems = componentHelper.getEnum('alignItems', me.data.alignItems);
        const flexWrap = componentHelper.getEnum('flexWrap', me.data.flexWrap);

        const root = Node.create();

        me.data.widthAuto ? root.setWidthAuto() : root.setWidth(width);
        me.data.heightAuto ? root.setHeightAuto() : root.setHeight(height);

        root.setMargin(marginEdge, margin);
        root.setPadding(paddingEdge, padding);
        root.setFlexDirection(flexDirection);
        root.setJustifyContent(justifyContent);
        root.setAlignContent(alignContent);
        root.setAlignItems(alignItems);
        root.setFlexWrap(flexWrap);

        // add children
        let map = [];
        let index = 0;

        for (let child of me.el.children) {

            if (!child.hasLoaded) {
                continue;
            }

            // skip invisible items

            if (child.components.hasOwnProperty('visible') && child.components.visible.data === false) {
                continue;
            }

            if (!child.components.hasOwnProperty('geometry')) {
                continue;
            }

            if (!child.components.hasOwnProperty('yoga-layout-item')) {
                continue;
            }

            let childGeometry = child.components.geometry;
            let childYogaLayoutItem = child.components['yoga-layout-item'];

            let w = childGeometry.data.width;
            let h = childGeometry.data.height;

            let childPosition = componentHelper.getEnum('position', childYogaLayoutItem.data.position);
            let childLeft = componentHelper.toPixels(childYogaLayoutItem.data.left);
            let childRight = componentHelper.toPixels(childYogaLayoutItem.data.right);
            let childTop = componentHelper.toPixels(childYogaLayoutItem.data.top);
            let childBottom = componentHelper.toPixels(childYogaLayoutItem.data.bottom);

            const childPadding = componentHelper.toPixels(childYogaLayoutItem.data.padding);
            const childPaddingEdge = componentHelper.getEnum('edge', childYogaLayoutItem.data.paddingEdge);
            const childMargin = componentHelper.toPixels(childYogaLayoutItem.data.margin);
            const childMarginEdge = componentHelper.getEnum('edge', childYogaLayoutItem.data.marginEdge);

            let node = Node.create();
            node.setWidth(componentHelper.toPixels(w));
            node.setHeight(componentHelper.toPixels(h));
            node.setMargin(childMarginEdge, childMargin);
            node.setPadding(childPaddingEdge, childPadding);

            node.setPositionType(childPosition);
            if (!isNaN(childLeft)) {
                node.setPosition(yoga.EDGE_LEFT, childLeft);
            }
            if (!isNaN(childRight)) {
                node.setPosition(yoga.EDGE_RIGHT, childRight);
            }
            if (!isNaN(childTop)) {
                node.setPosition(yoga.EDGE_TOP, childTop);
            }
            if (!isNaN(childBottom)) {
                node.setPosition(yoga.EDGE_BOTTOM, childBottom);
            }

            map.push({
                child: child,
                node: node,
            });

            root.insertChild(node, index);
            index++;
        }

        // calculate root
        root.calculateLayout();
        const rootLayout = root.getComputedLayout();

        me.el.setAttribute('geometry', {
            width: componentHelper.toMeters(rootLayout.width),
            height: componentHelper.toMeters(rootLayout.height),
        });

        for (let item of map) {
            let child = item.child;
            let node = item.node;
            let layout = node.getComputedLayout();

            // y-reversed positioning

            child.setAttribute('position', {
                x: componentHelper.toMeters(layout.left - (rootLayout.width / 2) + (layout.width / 2)),
                y: componentHelper.toMeters(-(layout.top - (rootLayout.height / 2) + (layout.height / 2))),
                z: 0,
            });
        }
    }
});

AFRAME.registerPrimitive('a-yoga-layout', {
    defaultComponents: {
        'yoga-layout': {}
    },
    mappings: {
        'width': 'yoga-layout.width',
        'height': 'yoga-layout.height',
        'width-auto': 'yoga-layout.widthAuto',
        'height-auto': 'yoga-layout.heightAuto',
        'padding': 'yoga-layout.padding',
        'margin': 'yoga-layout.margin',
        'padding-edge': 'yoga-layout.paddingEdge',
        'margin-edge': 'yoga-layout.marginEdge',
        'flex-direction': 'yoga-layout.flexDirection',
        'justify-content': 'yoga-layout.justifyContent',
        'align-content': 'yoga-layout.alignContent',
        'align-items': 'yoga-layout.alignItems',
        'flex-wrap': 'yoga-layout.flexWrap',
    },
});